import React, { useEffect, useState } from 'react';
import { Dropdown, Form } from 'antd';
import cn from 'classnames';
import { Input } from 'components';
import { CityAutoSuggestProps, Option } from './types';
import { searchCitiesByName } from './utils';
import './style.scss';

export const CityAutoSuggest: React.FC<CityAutoSuggestProps> = ({
  className,
  name,
  label,
  rules,
  formItemProps,
  ...props
}) => {
  const form = Form.useFormInstance();
  const watchedValue = Form.useWatch(name, form);

  const [items, setItems] = useState<Option[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleChange = (value: string) => {
    setSearchValue(value);

    if (value) {
      const menuItems: Option[] = searchCitiesByName(value).map((item) => ({
        key: item.key,
        label: item.label,
      }));

      setItems(menuItems);
    } else {
      setItems([]);
    }
  };

  const handleSelect = (value: string) => {
    form.setFieldsValue({ [name]: value });
    setSearchValue(value);
    setDropdownOpen(false);
  };

  const handleFocus = () => {
    if (searchValue && items.length > 0) {
      setDropdownOpen(true);
    }
  };

  const handleBlur = () => {
    setTimeout(() => {
      setDropdownOpen(false);
    }, 100);
  };

  useEffect(() => {
    setSearchValue(watchedValue);
    if (watchedValue) {
      handleChange(watchedValue);
    } else {
      setItems([]);
      setDropdownOpen(false);
    }
  }, [watchedValue]);

  return (
    <div className={cn('form-item_city_auto_suggest', className)}>
      <Dropdown
        menu={{
          items,
          onClick: ({ key }) => handleSelect(key),
        }}
        open={dropdownOpen}
        trigger={[]}
        placement="bottomLeft"
        overlayClassName="form-item_city_auto_suggest__dropdown"
      >
        <Input
          name={name}
          label={label}
          rules={rules}
          formItemProps={formItemProps}
          value={searchValue}
          autoComplete="off"
          onChange={(e) => {
            handleChange(e.target.value);
            setDropdownOpen(!!e.target.value);
          }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...props}
        />
      </Dropdown>
    </div>
  );
};
